import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

export const prependCMSUrl = (imageUrl: string) =>
  imageUrl.startsWith('http') ? imageUrl : config.cms.url + imageUrl;
